// extracted by mini-css-extract-plugin
export default {"boldLetter":"highlightText_boldLetter__Ob4vk"};